<template>
  <div>
    <v-row>
      <v-col cols="3">
        <v-text-field
          label="Фамилия"
          outlined
          v-model="v.lastName.$model"
          :errorMessages="getValidationErrorText(v.lastName)"
        />
      </v-col>
      <v-col cols="3">
        <v-text-field
          label="Имя"
          outlined
          v-model="v.firstName.$model"
          :errorMessages="getValidationErrorText(v.firstName)"
        />
      </v-col>
      <v-col cols="3">
        <v-text-field
          label="Отчество (при наличии)"
          outlined
          v-model="v.patronymic.$model"
          :errorMessages="getValidationErrorText(v.patronymic)"
        />
      </v-col>
      <v-col cols="3">
        <DateFieldCustom
          label="Дата рождения"
          :value="v.birthDate.$model"
          @change="v.birthDate.$model = $event"
          :errorMessage="v.birthDate"
          :max="new Date().toISOString()"
        />
      </v-col>

      <v-col cols="3">
        <v-text-field
          v-model="v.snils.$model"
          :errorMessages="getValidationErrorText(v.snils)"
          label="СНИЛС"
          v-mask="['###-###-### ##']"
          outlined
        />
      </v-col>
      <v-col cols="3">
        <v-text-field
          v-model="v.inn.$model"
          :errorMessages="getValidationErrorText(v.inn)"
          label="ИНН"
          v-mask="['############']"
          outlined
        />
      </v-col>
      <v-col cols="3">
        <v-text-field
          v-model="v.email.$model"
          :errorMessages="getValidationErrorText(v.email)"
          label="Адрес электронной почты"
          outlined
        />
      </v-col>
      <v-col cols="3" v-if="!v.isTrustee.$model">
        <v-text-field
          v-model="v.phone.$model"
          :errorMessages="getValidationErrorText(v.phone)"
          v-mask="Mask.PHONE"
          label="Контактный телефон"
          outlined
        />
      </v-col>

      <v-col cols="12">
        <v-checkbox
          v-model="v.isTrustee.$model"
          label="Подать заявление как представитель заявителя"
          hide-details
        />
      </v-col>
    </v-row>

    <PersonTrustee v-if="v.isTrustee.$model" :v="v.trustee" />
  </div>
</template>

<script>
import {
  and,
  maxLength,
  minLength,
  required,
  requiredIf,
} from 'vuelidate/lib/validators';
import {
  PERSON_NAME,
  EMAIL,
  getValidationErrorText,
  INN_ROD,
  MAX_LENGTH,
  MAX_LENGTH_EMAIL,
  MinLength,
  SNILS_ROD,
  DATE_FORMAT,
  DATE_FUTURE,
  DATE_PAST,
} from '@/utils/validate';
import { Mask } from '@/constants';
import DateFieldCustom from '@/components/base/DateFieldCustom';
import PersonTrustee, {
  personTrusteeModel,
  personTrusteeValidation,
} from './PersonTrustee';
import cloneDeep from 'clone-deep';

export const personModel = {
  lastName: '',
  firstName: '',
  patronymic: '',
  birthDate: '',
  snils: '',
  inn: '',
  phone: '',
  email: '',
  isTrustee: false,
  trustee: cloneDeep(personTrusteeModel),
};

export const personValidation = (person) => ({
  lastName: {
    required,
    maxLength: maxLength(MAX_LENGTH),
    PERSON_NAME,
  },
  firstName: {
    required,
    maxLength: maxLength(MAX_LENGTH),
    PERSON_NAME,
  },
  patronymic: {
    maxLength: maxLength(MAX_LENGTH),
    PERSON_NAME,
  },
  birthDate: {
    required,
    DATE: and(DATE_FORMAT, DATE_FUTURE, DATE_PAST),
  },
  snils: {
    required,
    minLength: minLength(MinLength.SNILS),
    SNILS: SNILS_ROD,
  },
  inn: {
    required,
    minLength: minLength(12),
    INN: INN_ROD,
  },
  phone: {
    required: requiredIf((vm) => !vm.isTrustee),
    minLength: minLength(16),
  },
  email: {
    required,
    EMAIL,
    maxLength: maxLength(MAX_LENGTH_EMAIL),
  },
  isTrustee: {},
  trustee: personTrusteeValidation(person.isTrustee),
});

export default {
  name: 'Person',
  props: {
    v: {
      type: Object,
      required: true,
    },
  },
  components: {
    DateFieldCustom,
    PersonTrustee,
  },
  data: () => ({
    Mask,
    getValidationErrorText,
  }),
};
</script>
